import { useEffect, useState } from "react";
import { createProtectedObjectUrl } from "@/lib/assets";

export function useProtectedAssetUrl(path, enabled = true) {
  const [assetUrl, setAssetUrl] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    let active = true;
    let currentUrl = null;

    if (!enabled || !path) {
      setAssetUrl(null);
      return () => {};
    }

    setLoading(true);
    createProtectedObjectUrl(path)
      .then((url) => {
        currentUrl = url;
        if (active) setAssetUrl(url);
      })
      .catch(() => {
        if (active) setAssetUrl(null);
      })
      .finally(() => {
        if (active) setLoading(false);
      });

    return () => {
      active = false;
      if (currentUrl) URL.revokeObjectURL(currentUrl);
    };
  }, [enabled, path]);

  return { assetUrl, loading };
}
